<template src="./html/Navbar.html"></template>

<script>
	import ChooseLanguage from './../../chooseLanguage/layout/ChooseLanguage.vue'

	export default {
		props: ['user', 'isAuth', 'menus', 'authentication'],
		components: {
			'choose-language': ChooseLanguage,
		},
		mounted() {
			this.init()
		},
		watch: {
			'$route'() {
				var body = $("body")
				if(body.hasClass('show-sidebar')) {
					body.toggleClass("show-sidebar")
				}
			},
			user() {
				this.pusher()
				this.$nextTick( () => this.loadSidebar())
			},
		},
		methods: {
			init() {
				$('#dropdown-tasks').on('click', function(e) {
					e.stopPropagation();
				})
			},
			loadSidebar() {
				var body = $("body")

				/* ===== Theme Settings ===== */
				$(".open-close").on("click", function () {
					body.toggleClass("show-sidebar");
				});

				/* ===== Open-Close Right Sidebar ===== */

				$(".right-side-toggle").on("click", function () {
					$(".right-sidebar").slideDown(50).toggleClass("shw-rside");
					$(".fxhdr").on("click", function () {
						body.toggleClass("fix-header"); /* Fix Header JS */
					});
					$(".fxsdr").on("click", function () {
						body.toggleClass("fix-sidebar"); /* Fix Sidebar JS */
					});

					/* ===== Service Panel JS ===== */

					var fxhdr = $('.fxhdr');
					if (body.hasClass("fix-header")) {
						fxhdr.attr('checked', true);
					} else {
						fxhdr.attr('checked', false);
					}
				});

				var set = function () {
						var topOffset = 60,
							width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width,
							height = ((window.innerHeight > 0) ? window.innerHeight : this.screen.height) - 1;
						if (width < 768) {
							$('div.navbar-collapse').addClass('collapse');
							topOffset = 100; /* 2-row-menu */
						} else {
							$('div.navbar-collapse').removeClass('collapse');
						}

						/* ===== This is for resizing window ===== */

						if (width < 1170) {
							body.addClass('content-wrapper');
							$(".sidebar-nav").css("overflow-x", "visible").parent().css("overflow", "visible");
						} else {
							body.removeClass('content-wrapper');
						}

						height = height - topOffset;
						if (height < 1) {
							height = 1;
						}
						if (height > topOffset) {
							$("#page-wrapper").css("min-height", (height) + "px");
						}
					},
					url = window.location,
					element = $('ul.nav a').filter(function () {
						return this.href === url || url.href.indexOf(this.href) === 0;
					}).addClass('active').parent().parent().addClass('in').parent();
				if (element.is('li')) {
					element.addClass('active');
				}
				$(window).ready(set);
				$(window).bind("resize", set);
			},
			pusher() {
				if(this.$platform) {
					var that = this
					var channel = this.$pusher.subscribe(this.$platform.slug + '-new-notifications-user-' + this.user.id)
					channel.bind('new-notifications', function(data) {
						that.$emit('reload')
					})
				}
			},
			read(notification) {
				if(!notification.read_at) {
					var data = {
						notification: notification
					}
					this.$http.post('admin/notifications/read', data)
						.then(response => {
							//-- Delete notification from the unread notification list
							let index = this.user.unread_notifications.indexOf(notification)
							this.user.unread_notifications.splice(index, 1)
							//-- Update notification as read
							index = this.user.notifications.indexOf(notification)
							this.user.notifications[index] = response.body
						}).catch(function(response) {
							console.log(response)
						})
				}
			},
			showNotification(notification) {
				$('#dropdown-notifications').dropdown('toggle')
				var link = notification.data.link
				if(link) {
					if(this.$platform) {
						this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + link)
					}
				}
				if(!notification.read_at) {
					var data = {
						notification: notification
					}
					this.$http.post('admin/notifications/read', data)
						.then(response => {
							//-- Delete notification from the unread notification list
							let index = this.user.unread_notifications.indexOf(notification)
							this.user.unread_notifications.splice(index, 1)
							//-- Update notification as read
							index = this.user.notifications.indexOf(notification)
							this.user.notifications[index] = response.body
						}).catch(function(response) {
							console.log(response)
						})
				}
			},
			toHome() {
				if(this.$platform) {
					var home = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin'
					if(this.$platform) {
						if(this.$platform.setting) {
							var main_package_id = this.$platform.setting.main_package_id
							if(main_package_id) {
								if(main_package_id == 1) {
									home += '/cms'
								}
								if(main_package_id == 2) {
									home += '/management'
								}
								if(main_package_id == 3) {
									home += '/projects'
								}
							}
						}
					}
					return home
				}
			}
		}
	};
</script>

<style type="text/css" media="screen">
	.dropdown-tasks p {
		font-size: 13px;
		line-height: 1;
	}

	.dropdown-tasks .noty-unread a {
		padding: 20px 9px 2px 9px;
	}

	.notification-created-at{
		font-size: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/partials/views/Navbar.vue